import { Typography } from '@mui/material'

const LabelComponent = ({ text, obligatorio = 'N' }) => {
  return (
    <Typography
      id="solicitud-label-component"
      variant="h3"
      sx={{ mb: 1, fontSize: '1rem', ml: 0, fontWeight: obligatorio === 'N' ? '400' : '500' }}
    >
      {text}
      {obligatorio === 'N' ? <></> : <sup>*</sup>}
    </Typography>
  )
}

export default LabelComponent
